import { render, staticRenderFns } from "./choseDept.vue?vue&type=template&id=650969bd&scoped=true&"
import script from "./choseDept.vue?vue&type=script&lang=ts&"
export * from "./choseDept.vue?vue&type=script&lang=ts&"
import style1 from "./choseDept.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650969bd",
  null
  
)

export default component.exports